import React, {useMemo, useRef, useState} from "react";
import {Badge, Modal as AntdModal} from "antd";
import {Link, useSearchParams} from "react-router-dom";
import {useOpportunity} from "../../../providers/OpportunityProvider";
import OppRejectionFeedbackModal from "../../talent-opportunities/components/OppRejectionFeedbackModal";
import Modal from "../../../components/Modal";
import UserImageCircle from "../../../components/UserImageCircle";
import MatchedTalentCoverLetterEditTab from "./MatchedTalentCoverLetterEditTab";

const CollapseRolesHeader = ({talentUserOpp, isActive, onToggle}) => {
    const [searchParams, setSearchParams] = useSearchParams();

    const {
        onShowInterest,
        onWithdraw,
        onRemoveInterest,
        onAccept,
        onReject,
        isDisabled
    } = useOpportunity();

    const [showInterestForTalent, setShowInterestForTalent] = useState(false)

    const rejectModal = useRef(null)
    const [showRejection, setShowRejection] = useState(false);

    const showInterest = () => {
        if (talentUserOpp.has_shown_interest_in_job || !talentUserOpp.can_show_interest_in_job) {
            return;
        }
        return onShowInterest(talentUserOpp, {for_agency: true, talent_user_id: talentUserOpp.user?.id})
    }
    const showInterestForTalentOpp = async (params) => {
        if (params) {
            let updateParams = {...params};

            if (!showInterestForTalent.job_candidate?.talent_proposed_at) {
                updateParams.job_candidate = {
                    ...(updateParams.job_candidate || {}),
                    talent_proposed_at: new Date()
                };
            }
            let updatedOpp;
            if (!showInterestForTalent?.id && !showInterestForTalent?.project_position?.has_shown_interest_in_job) {
                updatedOpp = await onShowInterest(talentUserOpp, {for_agency: true, talent_user_id: talentUserOpp.user?.id, ...(updateParams.job_candidate || {})});
                if (!updatedOpp) {
                    return;
                }
            }
        }

        return setShowInterestForTalent(false);
    }

    const removeInterest = () => {
        if (!talentUserOpp.has_shown_interest_in_job || !talentUserOpp.can_remove_interest_in_job) {
            return;
        }
        return onRemoveInterest(talentUserOpp, {for_agency: true, talent_user_id: talentUserOpp.user?.id})
    }

    const acceptOpp = () => {
        if (!talentUserOpp.isAvailable() || !talentUserOpp.can_be_accepted) {
            return;
        }
        return onAccept(talentUserOpp, {for_agency: true, talent_user_id: talentUserOpp.user?.id})
    }

    const toggleRejectionModal = () => {
        return rejectModal?.current?.showModal()
    }
    const rejectOpp = () => {
        if (!talentUserOpp.isAvailable() || !talentUserOpp.can_be_rejected) {
            return;
        }

        return onReject(talentUserOpp, {for_agency: true, talent_user_id: talentUserOpp.user?.id})
    }

    const withdrawOpp = () => {
        if (!talentUserOpp.isAvailable() || !talentUserOpp.can_be_withdrawn) {
            return;
        }
        return onWithdraw(talentUserOpp.project_position, {for_agency: true, talent_user_id: talentUserOpp.user?.id})
    }

    // has_shown_interest_in_job
    // has_signable_contract
    // can_be_accepted
    // can_be_rejected
    // can_be_withdrawn
    // has_signable_contract
    // has_shown_interest_in_job
    // is_match
    // can_show_interest_in_job
    // can_remove_interest_in_job
    // status
    // accepted_at
    // rejected_at
    // withdrew_at

    // isInvited()
    // isInterested
    // isActive
    // isCompleted
    // isProposing
    // isPendingContract
    // isWithdrawn
    // isLost
    // isRejected
    // isAvailable
    // isOnHold

    const isEditingPayout = useMemo(() => {
        return isActive && searchParams.get('tabView') === 'payout'
    }, [isActive, searchParams.get('tabView')]);

    const isEditingRate = useMemo(() => {
        return isActive && searchParams.get('tabView') === 'rate'
    }, [isActive, searchParams.get('tabView')]);

    const isEditingAvailability = useMemo(() => {
        return isActive && searchParams.get('tabView') === 'availability'
    }, [isActive, searchParams.get('tabView')]);

    const isEditingCoverLetter = useMemo(() => {
        return isActive && searchParams.get('tabView') === 'cover-letter'
    }, [isActive, searchParams.get('tabView')]);

    const isEditingRelevantExp = useMemo(() => {
        return isActive && searchParams.get('tabView') === 'relevant-experience'
    }, [isActive, searchParams.get('tabView')]);

    const isEditingMatchScore = useMemo(() => {
        return isActive && searchParams.get('tabView') === 'match-score'
    }, [isActive, searchParams.get('tabView')]);

    const openTab = (tab) => {
        let params = new URLSearchParams(searchParams);
        params.set('tabView', tab);
        return setSearchParams(params, {replace: true})
    }
    const editAvailability = async () => {
        await onToggle();
        return openTab('availability')
    }
    const editRate = async () => {
        await onToggle();
        return openTab('rate')
    }
    const editPayout = async () => {
        await onToggle();
        return openTab('payout')
    }
    const editCoverLetter = async () => {
        await onToggle();
        return openTab('cover-letter')
    }

    const editRelevantExp = async () => {
        await onToggle();
        return openTab('relevant-experience')
    }
    const editMatching = async () => {
        await onToggle();
        return openTab('match-score')
    }

    const showInterviews = async () => {
        await onToggle();
        return openTab('interviews')
    }
    return (
        <div>
            <div className="flex flex-row flex-wrap gap-3">
                <div className="flex flex-row items-center gap-4 flex-1">
                    {talentUserOpp.user && (
                        <UserImageCircle user={talentUserOpp.user} size={55} className="img-fluid"/>)}
                    <div>
                        <p className="text-semibold">{talentUserOpp.team ? talentUserOpp.team.name : `${talentUserOpp.user?.first_name} ${talentUserOpp.user?.last_name}`}</p>
                        <p className="text-xs text-light-gray4 whitespace-nowrap">
                            {TB.join(TB.map(talentUserOpp.disciplines || [], 'name'), ', ')}
                        </p>
                    </div>
                </div>

                <div className="flex items-center flex-1 justify-start">
                    <p>${talentUserOpp.max_hourly_rate}/hr</p>

                    <Link target="_blank" to={`/supplier/talent-resources/${talentUserOpp.user?.id}`}
                          className="btn btn-link px-2">
                        Edit Profile
                    </Link>
                </div>

                {talentUserOpp.matching && (
                    <div className="flex items-center flex-1 justify-start">
                        <p>{Math.round(talentUserOpp.matching.overall?.percent)}% Match</p>
                        {!isEditingMatchScore && talentUserOpp.id && talentUserOpp.is_match && !talentUserOpp.is_dead && (
                            <button
                                type="button"
                                disabled={isDisabled}
                                onClick={() => editMatching()} className="btn btn-link px-2">
                                Update Skills
                            </button>
                        )}
                    </div>
                )}

                <div className="flex items-center justify-start w-[110px]">
                    <Badge
                        count={talentUserOpp?.id ? talentUserOpp.display_status : (talentUserOpp.is_match ? 'Match' : 'No Match')}
                        color={talentUserOpp.statusColor()}/>
                </div>

                <div className="flex items-center justify-end w-[130px] gap-2">

                    {!talentUserOpp.id && talentUserOpp.is_match && talentUserOpp.can_show_interest_in_job && (
                        <button
                            type="button"
                            disabled={isDisabled}
                            onClick={() => setShowInterestForTalent(talentUserOpp)} className="btn btn-success text-white">
                            Show Interest
                        </button>
                    )}
                    {talentUserOpp.isInterested() && talentUserOpp.can_remove_interest_in_job && (
                        <button
                            type="button"
                            disabled={isDisabled}
                            onClick={() => removeInterest()} className="btn btn-dark text-white">
                            Remove Interest
                        </button>
                    )}
                    {talentUserOpp.isInvited() && (
                        <React.Fragment>
                            {talentUserOpp.can_be_accepted && (
                                <button
                                    type="button"
                                    disabled={isDisabled}
                                    onClick={() => acceptOpp()} className="btn btn-info text-white">
                                    Pursue
                                </button>
                            )}
                            {talentUserOpp.can_be_rejected && (
                                <button
                                    type="button"
                                    disabled={isDisabled}
                                    onClick={() => toggleRejectionModal()} className="btn btn-dark text-white">
                                    Pass
                                </button>
                            )}
                        </React.Fragment>
                    )}

                    {talentUserOpp.isAccepted() && talentUserOpp.isPendingContract() && talentUserOpp.has_signable_contract && (
                        <button
                            type="button"
                            disabled={isDisabled}
                            onClick={() => toggleRejectionModal()} className="btn btn-secondary text-white">
                            Review Contract and Signed
                        </button>
                    )}
                    {talentUserOpp.isAccepted() && talentUserOpp.can_be_withdrawn && (
                        <button
                            type="button"
                            disabled={isDisabled}
                            onClick={() => toggleRejectionModal()} className="btn btn-dark text-white">
                            Withdraw
                        </button>
                    )}


                </div>

                <div className="flex ml-auto items-center flex-row flex-nowrap">
                    <button type="button" onClick={() => {
                        onToggle();
                    }} disabled={!talentUserOpp.canMessageAndAcceptInterviews()}
                            className={TB.mapClass("p-3 relative", {
                                'opacity-0': !talentUserOpp.canMessageAndAcceptInterviews()
                            })}>
                        {talentUserOpp.canMessageAndAcceptInterviews() && !!talentUserOpp.job_candidate?.unread_messages_count && (
                            <Badge count={talentUserOpp.job_candidate.unread_messages_count} size="small"
                                   className="absolute top-0 right-0.5"/>
                        )}
                        <i className="fas fa-comment-alt text-light-gray6"/>
                    </button>
                    <button type="button" onClick={showInterviews}
                            disabled={!talentUserOpp.canMessageAndAcceptInterviews()}
                            className={TB.mapClass("p-3 relative", {
                                'opacity-0': !talentUserOpp.canMessageAndAcceptInterviews()
                            })}>

                        {talentUserOpp.canMessageAndAcceptInterviews() &&
                            (!!talentUserOpp.job_candidate?.upcoming_meetings_count || !!talentUserOpp.job_candidate?.proposed_meetings_count) && (
                                <Badge
                                    count={talentUserOpp.job_candidate.upcoming_meetings_count + talentUserOpp.job_candidate.proposed_meetings_count}
                                    size="small" className="absolute top-0 right-0.5"/>
                            )}
                        <i className="fas fa-calendar-alt text-light-gray6"/>
                    </button>
                </div>
            </div>

            <div className="rounded-lg p-4 mt-4 border-wrippleLightGrayBg border-solid bg-[#FAFBFC] border-[1px]">


                <p className="text-bold text-wripplePrimaryDarkNavy">Project Proposal</p>

                <div className="flex pt-4">

                    {talentUserOpp.isFixedFee() ? (
                        <React.Fragment>
                            <div className="flex-1">
                                <p className="text-xs text-wripplePrimaryDarkNavy whitespace-nowrap">
                                    Rate
                                </p>
                                <div className="flex flex-row gap-1.5 items-center flex-nowrap">
                                    <p>
                                        {talentUserOpp.id ? `$${talentUserOpp.job_candidate?.hourly_rate || talentUserOpp.job_candidate?.original_rate}/hr` : 'TBD'}
                                    </p>
                                    {!isEditingPayout && !talentUserOpp.is_dead && talentUserOpp.id && (
                                        <button onClick={editPayout} disabled={isDisabled}
                                                className="btn-link btn-link-info py-0">
                                            Edit
                                        </button>
                                    )}
                                </div>
                            </div>

                            <div className="flex-1">
                                <p className="text-xs text-wripplePrimaryDarkNavy whitespace-nowrap">
                                    Total Est. Hours
                                </p>
                                <div className="flex flex-row gap-1.5 items-center flex-nowrap">
                                    <p>
                                        {talentUserOpp.id ? (
                                            <span>{talentUserOpp.job_candidate?.total_hours} hours</span>
                                        ) : 'TBD'}
                                    </p>

                                    {!isEditingPayout && !talentUserOpp.is_dead && talentUserOpp.id && (
                                        <button onClick={editPayout} disabled={isDisabled}
                                                className="btn-link btn-link-info py-0">
                                            Edit
                                        </button>
                                    )}
                                </div>
                            </div>
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            <div className="flex-1">
                                <p className="text-xs text-wripplePrimaryDarkNavy whitespace-nowrap">
                                    Rate
                                </p>
                                <div className="flex flex-row gap-1.5 items-center flex-nowrap">
                                    <p>
                                        {talentUserOpp.id ? `$${talentUserOpp.job_candidate?.hourly_rate || talentUserOpp.job_candidate?.original_rate}/hr` : 'TBD'}
                                    </p>
                                    {!isEditingRate && !talentUserOpp.is_dead && talentUserOpp.id && (
                                        <button onClick={editRate} disabled={isDisabled}
                                                className="btn-link btn-link-info py-0">
                                            Edit
                                        </button>
                                    )}
                                </div>
                            </div>

                            <div className="flex-1">
                                <p className="text-xs text-wripplePrimaryDarkNavy whitespace-nowrap">
                                    Can Start
                                </p>
                                <div className="flex flex-row gap-1.5 items-center flex-nowrap">
                                    <p>
                                        {talentUserOpp.id ? (
                                            TB.moment(talentUserOpp.job_candidate?.confirmed_started_at || talentUserOpp.project_position?.started_at)
                                                ?.format('M/D/YYYY')
                                        ) : 'TBD'}
                                    </p>

                                    {!isEditingAvailability && !talentUserOpp.is_dead && talentUserOpp.id && (
                                        <button onClick={editAvailability} disabled={isDisabled}
                                                className="btn-link btn-link-info py-0">
                                            Edit
                                        </button>
                                    )}
                                </div>
                            </div>
                        </React.Fragment>
                    )}

                    <div className="flex-1">
                        <p className="text-xs text-wripplePrimaryDarkNavy whitespace-nowrap">
                            Cover Letter
                        </p>
                        <p>{TB.stripHtml(talentUserOpp.job_candidate?.cover_letter)?.length > 0 ? (
                            <span className="flex flex-row items-center flex-nowrap gap-1.5">
                                <span className="inline">
                                    {TB.stripHtml(talentUserOpp.job_candidate?.cover_letter).substr(0, 15)}...
                                </span>
                                {!isEditingCoverLetter && !talentUserOpp.is_dead && talentUserOpp.id && (
                                    <button onClick={editCoverLetter} disabled={isDisabled}
                                            className="btn-link btn-link-info py-0">
                                        Edit
                                    </button>
                                )}
                            </span>
                        ) : '--'}</p>
                    </div>

                    <div className="flex-1">
                        <p className="text-xs text-wripplePrimaryDarkNavy whitespace-nowrap">
                            Relevant Experience
                        </p>
                        <p>{TB.stripHtml(talentUserOpp.job_candidate?.relevant_experience)?.length > 0 ? (
                            <span className="flex flex-row items-center flex-nowrap gap-1.5">
                                <span className="inline">
                                    {TB.stripHtml(talentUserOpp.job_candidate?.relevant_experience).substr(0, 15)}...
                                </span>
                                {!isEditingRelevantExp && !talentUserOpp.is_dead && talentUserOpp.id && (
                                    <button onClick={editRelevantExp} disabled={isDisabled}
                                            className="btn-link btn-link-info py-0">
                                        Edit
                                    </button>
                                )}
                            </span>
                        ) : '--'}

                        </p>
                    </div>
                </div>
            </div>
            <Modal
                ref={rejectModal}
                modalClass={"opp-reject-feedback-modal"}
                title="Sorry this project doesn't fit your talent's needs."
                onCloseAction={async () => {
                    console.log('onClose Action')
                }}>

                <OppRejectionFeedbackModal
                    onCancel={() => rejectModal.current.hideModal(true)}
                    disabled={isDisabled}
                    onSubmit={async (model) => {
                        console.log('onsubmit', model);
                        await rejectModal.current.hideModal(true);


                        if (talentUserOpp.can_be_rejected) {
                            return rejectOpp()
                        }

                        if (talentUserOpp.can_be_withdrawn) {
                            return withdrawOpp()
                        }
                    }}
                />
            </Modal>
            <AntdModal
                open={!!showInterestForTalent}
                closable={!isDisabled}
                maskClosable={!isDisabled}
                footer={false}
                destroyOnClose={true}
                zIndex={101}
                title="Show interest for matched role"
                width="80vw"
                onCancel={() => setShowInterestForTalent(false)}
                onClose={() => setShowInterestForTalent(false)}>

                {!!showInterestForTalent && (
                    <MatchedTalentCoverLetterEditTab
                        onUpdate={showInterestForTalentOpp}
                        opportunity={showInterestForTalent}/>
                )}
            </AntdModal>

        </div>
    )
}

export default CollapseRolesHeader;